import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'CANCELLATION_POLICY',
  entryPoint: '/cancellation-policies',
  collectionName: 'daily_cancellation_policies',
  querySearchListing: [
    ['name'],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }] }),
  successMessageCreate: 'Cancellation policy created',
  successMessageUpdate: 'Cancellation policy updated',
  successMessageDelete: 'Cancellation policy deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/cancellation-policy/triggers.js